import {
    FETCH_DEVICE,
    FETCH_DEVICES,
    SEARCH_DEVICES,
} from '../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_DEVICES:
        case SEARCH_DEVICES:
            // overwrite the entire state
            return action.payload;
        case FETCH_DEVICE:

            let index = -1;
            for (var i = 0; i < state.length; i++) {
                if (state[i].id === action.payload.id) {
                    index = i;
                    break;
                }
            }

            if (index !== -1) {
                state[index] = action.payload;
            }

            return [...state];
        default:
            return state;
    }
};
